export { resources } from './resourceManager';
export type { AssetItem, AvatarItem } from './resourceManager';
export { CategoryName } from '@in3d/common';
